<template>
    <div>
        <loading v-if="loadingRender"></loading>
        <div class="d-flex justify-content-center">
            <div class="card p-3 m-3 w-100" >

                <div class="row" id="ZarinPalTr">

                    <div class="form-group text-right mt-2 mr-3 col-12 col-md-4">
                        <small>شبا</small>
                        <input type="email" class="form-control required" v-model="token">
                    </div>
                    <div class="col-md-2 col-12 mt-2 text-right ">
                        <small>تاریخ</small>
                        <date-picker :editable="true" :auto-submit="true" color="rgb(94 163 30)" v-model="date" :input-class="'required'">
                        </date-picker>
                        <input type="text" tabindex="-1" class="d-none InputText " style="direction: ltr" />
                    </div>

                    <div class="col-md-2 col-12 mt-3">
                        <input type="button" name="" value="جستجو" class="btn btn-success mt-2 w-100"
                            @click="search()" />
                    </div>

                    <div class="col-md-2 col-12 mt-3">
                        <export-excel :data="exceltable">
                            <i class="fas fa-file-excel btn btn-outline-success Pointer d-none" id="DownloadExcel">
                                دانلود فایل اکسل
                            </i>
                        </export-excel>
                    </div>
                </div>

            </div>
        </div>
        <div class="card p-3 m-3 d-flex justify-content-center" id="Date2">


            <vue-bootstrap4-table :rows="response" :columns="columns" :config="config" :classes="classes" 
                :actions="actions" @on-download="Download">
                <template slot="sort-asc-icon">
                    <i class="fa fa-sort-up"></i>
                </template>
                <template slot="sort-desc-icon">
                    <i class="fa fa-sort-down"></i>
                </template>
                <template slot="no-sort-icon">
                    <i class="fa fa-sort"></i>
                </template>
                <template slot="amount" slot-scope="props">
                    {{ $Comma3ragham(props.row.amount) }}
                </template>
                <template slot="empty-results">
                    <p class="text-right">اطلاعاتی یافت نشد</p>
                </template>
            </vue-bootstrap4-table>

            <!-- 
            <button v-if="date != '' & response.notInsertEnteghalDetails.length > 0"
                class="btn btn-primary col-12 col-md-2 mb-3">ثبت
                واریزی های {{ date }} </button> -->

        </div>

    </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";
import jalaali from 'moment-jalaali'
import moment from 'moment'
export default {
    beforeMount() {
        let token = this.$cookies.get('payStartToken')
        if (token != null)
            this.token = token
        this.response = []
    },
    data() {
        return {
            token: '',
            date: '',
            exceltable: [],
            Iban: '',
            response: [],
            columns: [{
                label: "id",
                name: "id",
                visibility: false,
            },

            {
                label: "شناسه ی پرداخت",
                name: "OrderId",
            },
            {
                label: "تاریخ",
                name: "date",
            },
            // {
            //     label: "شماره مرجع بانکی",
            //     name: "trackingCode",
            // },
            {
                label: "مبلغ تراکنش",
                name: "amount",
            },
            {
                label: "وضعیت",
                name: "Status",
            },
            {
                label: "تاریخ تسویه",
                name: "updatedDate",
            },


            ],
            actions: [{
                btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
                event_name: "on-download",
                class: "btn  mx-2 btn-outline-success rounded btnEXL ",
                event_payload: { msg: "my custom msg", },
            }],
            config: {
                pagination: true,
                pagination_info: false,
                per_page_options: [10, 20, 30, 50, 100],
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: true,
                card_title: "",
                card_mode: false,
                global_search: {
                    placeholder: " جستجو",
                    visibility: true,
                    case_sensitive: false,
                    showClearButton: true,
                    searchOnPressEnter: false,
                },
            },
            classes: {
                table: "table-bordered table-striped table-sm ",
            },
            loadingRender: false,
        }
    },
    components: {
        VueBootstrap4Table, loading
    },
    methods: {


        search() {

            if(this.$ValidForm('ZarinPalTr') == false){
                return;
            }

            let axios = {
                Method: "Post",
                Action: "TransactionService/GetZarinPal?sheba=" + this.token + "&date=" + this.date,
            }
            this.loadingRender = true;
            this.$PostData(axios).then((data) => {
                if (data.isSuccess == false) {
                    this.$mySweetDefaultTost("", data.message, "info", 2000);
                    this.response = []
                    this.loadingRender = false;
                    return
                }
                
                var dataJson = JSON.parse(data.data)
                console.log(dataJson)
                this.response = []
                dataJson.resource.forEach(x => {
                    this.response.push({
                        amount: x.amount,
                        date: jalaali(moment(x.created_at)).format('HH:mm:ss jYYYY/jMM/jDD'),
                        CardNumber: '',
                        TrackingCode: '',
                        OrderId: x.reference_session.id,
                        Status : x.status == "REACHED_AMOUNT" ? 'تسویه شده' : 'تسویه نشده',
                        updatedDate : x.status == "REACHED_AMOUNT" ? jalaali(moment(x.updated_at)).format('HH:mm:ss jYYYY/jMM/jDD') : '',
                    })
                })

                this.loadingRender = false;
            }).catch(err => {
                this.$mySweetDefaultTost("", "خطا در سرور", "error", 2000);
                this.loadingRender = false;
                throw err
            }).finally(() => {
            })

        },


        Getreport(server) {

            this.response = [];
            this.loadingRender = true;
            let info;
            let list = [];
            const formData = new FormData();
            formData.append('refNo', this.Iban);
            formData.append('Date', this.TarikhAz);
            formData.append('Server', server);
            this.DataAxiosRow.ArryfildValue = formData;
            this.$PostFormData(this.DataAxiosRow).then((data) => {
                if (data.length > 0) {
                    if (data.length > 10) {
                        this.config.pagination = true;
                    } else {
                        this.config.pagination = false;
                    }
                    for (let index = 0; index < data.length; index++) {
                        info = data[index];
                        list.push(info);
                    }
                    this.loadingRender = false;
                    this.response = this.$FormatMablaghGrid(list);
                    this.exelReport(this.rows);
                } else {
                    this.loadingRender = false;
                    this.$mySweetDefaultTost(
                        "عدم وجود اطلاعات",
                        "اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
                        "info",
                        2000
                    );
                    this.config.pagination = false;
                    this.response = [];
                }

            });
        },
        Download() {
            document.getElementById("DownloadExcel").click();
        },
        exelReport(response) {
            this.exceltable = [];
            response.forEach((element) => {
                var excelrow = {
                    "شماره رهگیری": element.internalReferenceId,
                    "تاریخ": element.draftDate,
                    "زمان": element.transactionTime,
                    "مبلغ تراکنش": element.amount,
                    "شماره کارت": element.pan,
                    "شماره حواله واریز": element.draftNumber,
                };

                this.exceltable.push(excelrow);
            });
            // console.log( this.exceltable);
        },
    }

}
</script>
<style scoped></style>